import React, { useMemo, useState } from "react";
import { columns } from "./columns";
import {
  Box,
  Typography,
  CircularProgress,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Table from "./../../../components/table/MuiTable";
import TableFilter from "../../../components/tableFilter";
import CursorPagination from "../../../components/pagination/CursorPagination";
import { fetchUserStatement } from "../../../apiCalls/urlFunction";
import { dateChanger } from "../../../shared/extra";
import moment from "moment/moment";
import { MobileSatement } from "./mobileStatement";

export default function Index() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [typeFilter, setTypeFilter] = useState("ALL");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // CUSTOM ROWS
const makeCustomRows = (arr) => {
  if (!Array.isArray(arr)) return [];

  return arr.map((item) => {
    const dataItem = item.node;

    const formatBalance = (value) => {
      const threshold = -0.0001;

      if (value < 0 && value > threshold) {
        return 0;
      }

      return Number(value || 0).toFixed(2);
    };

    return {
      id: dataItem.transactionId,
      createdAt: dataItem.createdAt,
      date: dateChanger(dataItem.createdAt),
      amount: Number(dataItem.amount || 0).toFixed(2),
      openingBal: formatBalance(dataItem.openingBalance),
      closingBal: formatBalance(dataItem.closingBalance),
      remark: dataItem?.remarks,

      // Normalize transaction type
      Status: String(dataItem?.transactionType || "")
        .trim()
        .toUpperCase(),
    };
  });
};
  // FILTER ROWS
const filteredRows = useMemo(() => {
  return rows.filter((row) => {
    const rowDate = moment(row?.createdAt);

    // Date filter tabhi lagega jab BOTH dates selected hon
    const isWithinDate =
      startDate && endDate
        ? rowDate.isSameOrAfter(moment(startDate), "day") &&
          rowDate.isSameOrBefore(moment(endDate), "day")
        : true;

    const isTypeMatch =
      typeFilter === "ALL" ||
      row?.Status === typeFilter;

    return isWithinDate && isTypeMatch;
  });
}, [rows, startDate, endDate, typeFilter]);

  // CLEAR FILTERS
  const handleClearFilters = () => {
    setTypeFilter("ALL");
    setStartDate("");
    setEndDate("");
  };

const isFiltered =
  typeFilter !== "ALL" ||
  !!startDate ||
  !!endDate;

  if (isMobile) {
    return <MobileSatement />;
  } else {
    return (
      <Box>
        <TableFilter
          options={["All", "Credit", "Debit"]}
          selectedValue={typeFilter}
          onChange={(val) => {
            setTypeFilter(val.toUpperCase());
          }}
          startDate={startDate}
          endDate={endDate}
          onDateChange={(type, value) => {
            if (type === "start") {
              setStartDate(value);
            } else {
              setEndDate(value);
            }
          }}
          onClearFilters={handleClearFilters}
        />

        {loading ? (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <CircularProgress />

            <Typography
              variant="body1"
              sx={{
                mt: 2,
                fontSize: "17px",
              }}
            >
              Loading....
            </Typography>
          </Box>
        ) : (
          <Table
            rows={filteredRows}
            columns={columns}
            errorMessage="Statement"
            loading={loading}
          />
        )}
        <CursorPagination
          fetchFunction={fetchUserStatement}
  limit={isFiltered ? 100 : 10}
          dependencies={[typeFilter, startDate, endDate]}
          onLoadingChange={setLoading}
          onDataChange={(data) => {
            setRows(makeCustomRows(data));
          }}
          responseMapper={(response) => ({
            data: response?.data?.edges || [],
            totalCount: response?.data?.totalCount || 0,
            endCursor: response?.data?.pageInfo?.endCursor || null,
          })}
        />
      </Box>
    );
  }
}
